<template>
  <div id="periodoVendasOnline">
    <q-btn-group rounded flat no-wrap no-caps>
      <q-btn class="white text-blue-7" rounded icon="chevron_left" data-test="periodo-anterior" @click="shiftPeriodo(-1)" />
      <q-btn class="white text-blue-7" rounded no-caps :label="modelValue.inicio" data-test="periodo-inicio">
        <q-popup-proxy transition-show="scale" transition-hide="scale">
          <div class="row no-wrap">
            <q-date
              :model-value="modelValue.inicio"
              :mask="MASCARA"
              :locale="langDate"
              minimal
              today-btn
              @update:model-value="(valor) => changePeriodo('inicio', valor)"
            />
            <q-time :model-value="modelValue.inicio" :mask="MASCARA" format24h @update:model-value="(valor) => changePeriodo('inicio', valor)" />
          </div>
        </q-popup-proxy>
      </q-btn>
      <q-btn class="white text-blue-7" rounded no-caps :label="modelValue.fim" data-test="periodo-fim">
        <q-popup-proxy transition-show="scale" transition-hide="scale">
          <div class="row no-wrap">
            <q-date
              :model-value="modelValue.fim"
              :mask="MASCARA"
              :locale="langDate"
              minimal
              today-btn
              @update:model-value="(valor) => changePeriodo('fim', valor)"
            />
            <q-time :model-value="modelValue.fim" :mask="MASCARA" format24h @update:model-value="(valor) => changePeriodo('fim', valor)" />
          </div>
        </q-popup-proxy>
      </q-btn>
      <q-btn class="white text-blue-7" rounded icon="chevron_right" data-test="periodo-proximo" @click="shiftPeriodo(1)" />
    </q-btn-group>
  </div>
</template>

<script>
import moment from "moment";
import { deslocarPeriodo } from "@/utils/venda-online-painel";

const MASCARA = "DD/MM/YYYY HH:mm";

export default {
  name: "vendas-online-periodo",
  props: {
    modelValue: { type: Object, required: true }
  },
  emits: ["update:modelValue"],
  data() {
    return { MASCARA };
  },
  methods: {
    shiftPeriodo(sentido) {
      this.$emit("update:modelValue", deslocarPeriodo(this.modelValue, sentido));
    },
    changePeriodo(lado, valor) {
      const periodo = { ...this.modelValue, [lado]: valor };
      const inicio = moment(periodo.inicio, MASCARA, true);
      const fim = moment(periodo.fim, MASCARA, true);

      if (lado === "inicio" && inicio.isAfter(fim)) periodo.fim = inicio.clone().endOf("day").format(MASCARA);
      if (lado === "fim" && fim.isBefore(inicio)) periodo.inicio = fim.clone().startOf("day").format(MASCARA);

      this.$emit("update:modelValue", periodo);
    }
  }
};
</script>
